import React from "react";
import GenericDetailsPage from "../../../Domain/Components/Functional/GenericDetailsPage/GenericDetailsPage";

function GameSessionDetailsPage(props) {
    return <GenericDetailsPage setLoggedIn={props.setLoggedIn}
                            title={"Tenant Details"}
                            endpoint={"tenant/read"}
                            relations={["campaigns", "operators"]}
                            manyToManyRelations={[{
                                name: "campaigns",
                                title: "Campaigns",
                                columnTitles: ["ID", "Currency ID", "Name", "Provider Campaign ID", "Contribution Type", "Contribution Amount", "Minimum Bet"],
                                objectKeys: ["id", "currency_id", "name", "provider_campaign_id", "contribution_type", "contribution_amount", "minimum_bet"],
                            },
                            {
                                name: "operators",
                                title: "Operators",
                                columnTitles: ["ID", "Company Name", "Parent ID", "Partner ID", "Flex Vendor Name", "Lobby Url", "Email", "Brand", "Type"],
                                objectKeys: ["id", "company_name", "parent_id", "partner_id", "flex_provider_name", "lobby_url", "email", "brand", "type"],
                            }
                            ]}
                             />
}

export default GameSessionDetailsPage;